import { layerSource,paintObject,property} from './Types';

import { Map } from './Map';

import { FeatureLayer } from './FeatureLayer';
import { LayerSpecification } from 'maplibre-gl';

import { FilterSpecification } from 'maplibre-gl';

export class PolygonVectorLayer extends FeatureLayer {
  constructor(
    layerSource: layerSource,
    mapObj: Map,
    sourceLayerId?: string,
    layerId?: string,
    sourceId?: string
  ) {
    super(layerSource, mapObj, sourceLayerId, layerId, sourceId);
  }

  addOutLine = (color: string = 'red', width: number = 1) => {
    // this.removeExtrusion();

    // const visibility = this.mapObj.getLayoutProperty(
    //   this.layerId,
    //   'visibility'
    // );

    let parentFilter = this.getFilter();

    if (this.mapObj.getLayer(`${this.layerId}$outline`)) {
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'line-color',
        color
      );
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'line-width',
        width
      );
    } else {
      this.mapObj.addLayer({
        id: `${this.layerId}$outline`,
        type: 'line',
        source: this.sourceId,
        'source-layer': this.sourceLayer,
        paint: {
          'line-color': color,
          'line-width': width,
        },
      });
    }
    
    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'outline');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'outline');

    this.setSubLayerFilter(<FilterSpecification>parentFilter,'outline');

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);

    if (this.mapObj.getLayer(`${this.layerId}$extrusion`)){
      this.mapObj.moveLayerOrder(`${this.layerId}$outline`, `${this.layerId}$extrusion`);
      this.mapObj.moveLayerOrder(`${this.layerId}$extrusion`, `${this.layerId}$outline`);
    }else {
      this.mapObj.moveLayerOrder(`${this.layerId}$outline`, this.layerId);
      this.mapObj.moveLayerOrder(this.layerId, `${this.layerId}$outline`);
    }

    
    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');

    // if (visibility === 'none') {
    //   this.mapObj.setLayoutProperty(
    //     `${this.layerId}$outline`,
    //     'visibility',
    //     'none'
    //   );
    // }
  };

  addExtrusion = (height: number = 100, base: number = 0, option:LayerSpecification = <LayerSpecification>{}) => {
    //&& this.mapObj.getLayer(this.layerId)?.type !== 'fill-extrusion'
    if (this.mapObj.getLayer(this.layerId)?.type !== 'fill') {
      throw `Invalid type: Layer type should be fill`;
    }

    let parentFilter = this.getFilter();

    // let visibility;

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);

    
    // visibility = this.mapObj.getLayoutProperty(this.layerId, 'visibility');
    

    // if (this.mapObj.getLayer(this.layerId)?.type === 'fill-extrusion'){
    //   let paint: paintObject;

    //   if (option.paint){
    //     paint = {
    //       'fill-extrusion-height': height,
    //       'fill-extrusion-base': base,
    //       ...option.paint
    //     }
    //   }else {
    //     paint =  {
    //       'fill-extrusion-color': <string>(
    //         this.mapObj.getPaintProperty(this.layerId, 'fill-extrusion-color')
    //       ),
    //       'fill-extrusion-height': height,
    //       'fill-extrusion-base': base,
    //     }
    //   }

    //   // this.mapObj.removeLayer(`${this.layerId}`, false);

    //   this.mapObj.addLayer({
    //     id: `${this.layerId}`,
    //     type: 'fill-extrusion',
    //     source: this.sourceId,
    //     'source-layer': this.sourceLayer,
    //     paint: paint,
    //     layout: option.layout || {}
    //   });
    // } else {

      if (this.mapObj.getLayer(`${this.layerId}$extrusion`)) {
        this.mapObj.removeLayer(`${this.layerId}$extrusion`);
      }

      let paint: paintObject;

      if (option.paint){
       paint = <paintObject>{
          'fill-extrusion-height': height,
          'fill-extrusion-base': base,
          ...option.paint
        }
      }else {
        paint =  {
          'fill-extrusion-color': <string>(
            this.mapObj.getPaintProperty(this.layerId, 'fill-color')
          ),
          'fill-extrusion-height': height,
          'fill-extrusion-base': base,
        }
      }
      // this.mapObj.removeLayer(`${this.layerId}`, false);

      this.mapObj.addLayer({
        id: `${this.layerId}$extrusion`,
        type: 'fill-extrusion',
        source: this.sourceId,
        'source-layer': this.sourceLayer,
        paint: paint,
        layout: option.layout || {}
      });

      this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'extrusion');
      this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'extrusion');

      this.setSubLayerFilter(<FilterSpecification>parentFilter,'extrusion');

      
      if (this.mapObj.getLayer(`${this.layerId}$outline`)){
        this.mapObj.moveLayerOrder(`${this.layerId}$extrusion`, `${this.layerId}$outline`);
        this.mapObj.moveLayerOrder(`${this.layerId}$outline`, `${this.layerId}$extrusion`);
      }else {
        this.mapObj.moveLayerOrder(`${this.layerId}$extrusion`, this.layerId);
        this.mapObj.moveLayerOrder(this.layerId, `${this.layerId}$extrusion`);
      }
      

      this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
      
    // }
    
    // this.colorType = 'fill-extrusion-color';

    // this.mapObj.moveLayerOrder(`${this.layerId}`, <number>newOrder)

    // if (visibility === 'none') {
    //   this.mapObj.setLayoutProperty(
    //     `${this.layerId}`,
    //     'visibility',
    //     'none'
    //   );
    // }

  };

  removeExtrusion = () => {

    if (this.mapObj.getLayer(`${this.layerId}$extrusion`)) {
      this.mapObj.removeLayer(`${this.layerId}$extrusion`);
    }

    // if (this.mapObj.getLayer(this.layerId)?.type === 'fill-extrusion'){
  
    //   let visibility = this.mapObj.getLayoutProperty(this.layerId, 'visibility');

    //   let newOrder = this.mapObj.style._order.indexOf(this.layerId);
     
    //   let paint: paintObject;

    //   paint =  {
    //     'fill-color': <string>(
    //       this.mapObj.getPaintProperty(this.layerId, 'fill-extrusion-color')
    //     )
    //   }
      
    //   this.mapObj.removeLayer(`${this.layerId}`, false);

    //   this.mapObj.addLayer({
    //     id: `${this.layerId}`,
    //     type: 'fill',
    //     source: this.sourceId,
    //     'source-layer': this.sourceLayer,
    //     paint: paint,
    //     layout: {}
    //   });
      
    //   this.mapObj.moveLayerOrder(`${this.layerId}`, <number>newOrder)

    //   this.colorType = 'fill-color';

    //   if (visibility === 'none') {
    //     this.mapObj.setLayoutProperty(
    //       `${this.layerId}`,
    //       'visibility',
    //       'none'
    //     );
    //   }
    // }

  };

  
  setExtrusionProperty = (type: property, value: string | number) => {
    if (!this.mapObj.getLayer(`${this.layerId}$extrusion`)) {
      return;
      // throw new Error("This layer has no extrusion!");
      
    }

    this._setLayerProperty(type, value, 'extrusion');

  };

  getExtrusionProperty = (type: property) => {
    if (!this.mapObj.getLayer(`${this.layerId}$extrusion`)) {
      return;
      // throw new Error("This layer has no extrusion!");
    }

    return this._getLayerProperty(type, 'extrusion');

  };
}
